mainApp.directive('cloudAccessRule', function() {
	return {
		templateUrl: '/public/directives/cloud-access-rule.directive.html',
		scope: {
			item: '=',
			tableConfig: '<',
			ruleType: '<',
			field: '<',
			fields: '<'
		},
		controller: cloudAccessRuleController
	}
});

function cloudAccessRuleController($scope) {

	$scope.removeException = function(exception) {
		$scope.item.exceptions.splice($scope.item.exceptions.indexOf(exception), 1);
	};

	$scope.hideEditor = function(fieldName) {
		$scope.$broadcast('hide-editor', $scope.item.id + fieldName);
	};

	$scope.showEditor = function(fieldName) {
		$scope.$broadcast('show-editor', $scope.item.id + fieldName);
	};
}